export const columnsPBData = [
  {
    Header: "ID",
    accessor: "id",
  },
  {
    Header: "BRANCH ID",
    accessor: "branch_id",
  },
  {
    Header: "BILL ID",
    accessor: "bill_id",
  },
  {
    Header: "ORDER BEGIN",
    accessor: "order_begin",
  },
  {
    Header: "AMOUNT",
    accessor: "amount",
  },
  {
    Header: "CUSTOMER TYPE",
    accessor: "type",
  },
  {
    Header: "DPP_PB1",
    accessor: "dpp_pb1",
  },
  {
    Header: "PB1",
    accessor: "pb1",
  },
  {
    Header: "DPP_PPN",
    accessor: "dpp_ppn",
  },
  {
    Header: "PPN",
    accessor: "ppn",
  },
  
];
